export const ORDER_STATUS = {
  pending_payment: { label: 'Pending Payment', tone: 'bg-amber-100 text-amber-800', step: 0 },
  payment_failed: { label: 'Payment Failed', tone: 'bg-red-100 text-red-800', step: 0 },
  paid: { label: 'New', tone: 'bg-emerald-100 text-emerald-800', step: 1 },
  confirmed: { label: 'Confirmed', tone: 'bg-sky-100 text-sky-800', step: 2 },
  packed: { label: 'Packed', tone: 'bg-blue-100 text-blue-800', step: 3 },
  processing: { label: 'Booking…', tone: 'bg-blue-100 text-blue-800', step: 3 },
  ready_to_ship: { label: 'Ready to Ship', tone: 'bg-indigo-100 text-indigo-800', step: 4 },
  picked_up: { label: 'Picked Up', tone: 'bg-violet-100 text-violet-800', step: 5 },
  shipped: { label: 'Shipped', tone: 'bg-violet-100 text-violet-800', step: 5 },
  in_transit: { label: 'In Transit', tone: 'bg-purple-100 text-purple-800', step: 5 },
  out_for_delivery: { label: 'Out for Delivery', tone: 'bg-cyan-100 text-cyan-800', step: 6 },
  delivered: { label: 'Delivered', tone: 'bg-green-100 text-green-800', step: 7 },
  rto: { label: 'RTO', tone: 'bg-orange-100 text-orange-900', step: 5 },
  cancelled: { label: 'Cancelled', tone: 'bg-rose-100 text-rose-800', step: -1 },
  returned: { label: 'Returned', tone: 'bg-gray-200 text-gray-800', step: -1 },
  return_requested: { label: 'Return Requested', tone: 'bg-orange-100 text-orange-900', step: -1 },
  return_approved: { label: 'Return Approved', tone: 'bg-teal-100 text-teal-800', step: -1 },
  return_rejected: { label: 'Return Rejected', tone: 'bg-slate-200 text-slate-700', step: -1 },
};

export const PIPELINE = [
  { key: '', label: 'All' },
  { key: 'paid', label: 'New' },
  { key: 'confirmed', label: 'Confirmed' },
  { key: 'packed,processing', label: 'Packed' },
  { key: 'ready_to_ship', label: 'Ready to Ship' },
  { key: 'picked_up,shipped,in_transit,out_for_delivery', label: 'In Transit' },
  { key: 'delivered', label: 'Delivered' },
  { key: 'rto', label: 'RTO' },
  { key: 'cancelled', label: 'Cancelled' },
];

export const STEPS = ['New', 'Confirmed', 'Packed', 'Ready', 'Picked up', 'Out for delivery', 'Delivered'];
export const IN_TRANSIT_SET = ['ready_to_ship', 'picked_up', 'shipped', 'in_transit', 'out_for_delivery'];
export const money = (v) => `₹${Number(v || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
